import { Injectable } from '@angular/core';
import { ReturnRouteModel } from './return-route.model';

@Injectable()
export class ReturnRouteService {

  routes: Array<ReturnRouteModel> = [];

  push( route: ReturnRouteModel) {
    this.routes.push(route);
  }

  pop(): ReturnRouteModel {
    return this.routes.pop();
  }

  peak(): ReturnRouteModel {
    return this.routes.length ? this.routes[this.routes.length - 1] : undefined;
  }

  clear() {
    this.routes = [];
  }
}
